
import { createSlice } from "@reduxjs/toolkit";

const caseStudySlice = createSlice({
    name: "caseStudy",
    initialState: {
        loading: false,
    },
    reducers: {

        caseStudyCreateLoading(state, action) {
            return {

                loading: true
            }
        },
        caseStudyCreateSuccess(state, action) {
            return {
                loading: false,
                caseStudy: action.payload.caseStudy,

            }
        },
        caseStudyCreatefail(state, action) {
            return {
                loading: false,
                error: action.payload,

            }
        },
        AllcaseStudyLoading(state, action) {
            return {

                loading: true
            }
        },
        AllcaseStudySuccess(state, action) {
            return {
                loading: false,
                allcaseStudy: action.payload.allCaseStudy,
            }
        },
        AllcaseStudyfail(state, action) {
            return {
                loading: false,
                error: action.payload,

            }
        },
        GetSinglecaseStudyLoading(state, action) {
            return {

                loading: true
            }
        },
        GetSinglecaseStudySuccess(state, action) {
            return {
                loading: false,
                SinglecaseStudy: action.payload.CaseStudy,
            }
        },
        GetSinglecaseStudyfail(state, action) {
            return {
                loading: false,
                error: action.payload,

            }
        },

        UpdatecaseStudyCreateLoading(state, action) {
            return {

                loading: true
            }
        },
        UpdatecaseStudyCreateSuccess(state, action) {
            return {
                loading: false,
                caseStudy: action.payload.caseStudy,
            }
        },
        UpdatecaseStudyCreatefail(state, action) {
            return {
                loading: false,
                error: action.payload,

            }
        },

        DeletecaseStudyLoading(state, action) {
            return {

                loading: true
            }
        },
        DeletecaseStudySuccess(state, action) {
            return {
                loading: false,
                caseStudy: action.payload.caseStudy,
            }
        },
        DeletecaseStudyFail(state, action) {
            return {
                loading: false,
                error: action.payload,

            }
        },
        

    }
})
const { actions, reducer } = caseStudySlice


export const { caseStudyCreateLoading, caseStudyCreateSuccess, caseStudyCreatefail, AllcaseStudyLoading,
    AllcaseStudySuccess, AllcaseStudyfail, GetSinglecaseStudyLoading, GetSinglecaseStudySuccess,
     GetSinglecaseStudyfail,UpdatecaseStudyCreateLoading,UpdatecaseStudyCreateSuccess,UpdatecaseStudyCreatefail,DeletecaseStudyLoading,DeletecaseStudySuccess,DeletecaseStudyFail } = actions

export default reducer